export enum ModalType {
    STANDARD = 'standard',
    LARGE = 'large',
    GARDES = 'gardes',
    NEXT_YEAR_TRANSITION = 'passage_annee_suivante',
}
